// HomePage.js
import React from "react";
import { IconButton } from "@mui/material";
import "./HomePage.css";
import ApproachSection from "../components/ApproachSection";
import Card from "../components/Card";
import Slideshow from "../components/Slideshow";
import InstagramSection from '../components/InstagramSection';

const HomePage = () => {
    const missionText = `Stimularea dezvoltării plenare a copiilor, prin intermediul unei oferte educaționale variate, cu accent pe educația centrată pe copil, prin respectarea drepturilor acestuia, prin cunoașterea și respectarea nevoilor și intereselor individuale, prin respectarea ritmului propriu de dezvoltare, oferind experiențe de învățare din diverse domenii de către cadre didactice competente, responsabile, dedicate și ocupate de evoluția în cariera didactică, totul într-un mediu securizat, atractiv, stimulativ, bazat pe modele practice de învățare și participarea tuturor factorilor interesați de dezvoltarea armonioasă.`;
    const mottoText = `„Educația este cheia pentru a deschide ușa de aur a libertății.” - George Washington Carver`;
    const visionText = `Tu ești copilul, Eu ţin în mâinile mele destinul tău, Eu determin, în mare măsură dacă vei reuși sau vei eșua în viață. Îți dau acele lucruri care să te îndrepte spre fericire, te voi educa, ca să poți fi o binecuvântare pentru lume.`;
    return (
        <div className="home-page">
            {/* Header with Navigation */}
            <header className="header">
                <div className="nav-container">
                    <IconButton edge="start" color="inherit" aria-label="home" href="/">
                        <img
                            src="/margot.jpg"
                            alt="Home Icon"
                            style={{ width: 40, height: 40, borderRadius: "50%" }}
                        />
                    </IconButton>
                </div>
            </header>

            <section className="hero">
                <Slideshow />
                <div className="hero-overlay">
                    <div className="hero-content">
                    <h1>
                        Grădinița cu Program Prelungit <b>"Margot"</b>
                    </h1>
                    <p>Locul în care copilăria colorează VISE!</p>
                    </div>
                </div>
            </section>

            {/* Main Content */}
            <main>
                {/* About Us Section */}
                <section id="about" className="about-section">
                    <h2>Despre noi</h2>
                    <div className="info-cards">
                        <Card title="Misiune" text={missionText} />
                        <Card title="Motto" text={mottoText} />
                        <Card title="Viziune" text={visionText} />
                    </div>
                </section>

                {/* Our Approach Section */}
                <ApproachSection />
                
                {/* Instagram Section */}
                <InstagramSection />

                {/* Regulations Section */}
                <section id="regulations" className="regulations-section">
                    <h2>Regulamente</h2>
                    <p>
                        Vă rugăm să consultați ghidurile și politicile noastre.
                    </p>
                    <div className="regulations-buttons">
                        <a
                            href="/Regulament de Ordine Interioara_MARGOT_2025-2026.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Regulament de Ordine Interioară
                        </a>
                        <a
                            href="/Regulament de organizare si funcționare_MARGOT_2025-2026.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Regulament de Organizare și Funcționare
                        </a>
                    </div>
                </section>

                {/* Contact Information Section */}
                <section id="contact" className="contact-section">
                    <h2>Contactați-ne</h2>
                    <div className="contact-info">
                        <div className="contact-card">
                            <div className="contact-icon">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <h3>Adresă</h3>
                            <p>str. Nicolaus Olahus, nr. 15, Oradea, jud. Bihor</p>
                        </div>
                        <div className="contact-card">
                            <div className="contact-icon">
                                <i className="fas fa-phone-alt"></i>
                            </div>
                            <h3>Telefon</h3>
                            <p>+40 756 358 294</p>
                            <p>+40 771 520 497</p>
                        </div>
                        <div className="contact-card">
                            <div className="contact-icon">
                                <i className="fas fa-envelope"></i>
                            </div>
                            <h3>Email</h3>
                            <p>gradinitamargot@gmail.com</p>
                        </div>
                    </div>
                </section>
            </main>

            {/* Footer */}
            <footer className="footer">
                <p>
                    &copy; 2025 <b>Margot</b>. Toate drepturile rezervate.
                </p>
            </footer>
        </div>
    );
};

export default HomePage;
